<template>
    <ion-row size="12" class="rewards-container d-flex ion-justify-content-center" data-cy="rewards-container">
        <ion-col size="12" class="ion-text-center py-0" data-cy="rewards-message">
            <ion-text style="font-size: 1.2em; color: black; font-weight: 500">Points, Perks, and Free Pizza.</ion-text>
        </ion-col>
        <ion-col size="12" class="d-flex ion-justify-content-center mb-8">
            <a @click="() => router.push('/signup')" data-cy="button-join-now" color="primary" class="pr-8 interstate-bold">JOIN DONATOS REWARDS</a>
            <a @click="() => router.push('/login')" data-cy="button-sign-in" color="primary" class="pl-8 interstate-bold">LOG IN</a>
        </ion-col>
    </ion-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { IonCol, IonRow, IonText } from '@ionic/vue';

export default defineComponent({
    setup() {
        const router = useRouter();
        return { router };
    },
    components: { IonCol, IonRow, IonText },
});
</script>

<style scoped>
.rewards-container {
    padding-top: 8px !important;
    background-color: #f0efed;
}

@media screen and (-webkit-device-pixel-ratio: 3) {
    .rewards-container {
        padding-top: 12px !important;
    }
}
</style>
